import React, { Component } from 'react'

import { graphql } from '@apollo/client/react/hoc'
import { useAdvancedFilters } from '../../Filters/filterUrl'
import { Table, UncontrolledTooltip, Popover, PopoverHeader, PopoverBody, Col, Row } from 'reactstrap'
import toTitleCase from '../../Functions/toTitleCase'
import moment from 'moment'
import gql from 'graphql-tag'
import PrimaryListingContainer from "../../Material/PrimaryListingContainer"
import { HasPermissionsQuery } from "../../Functions/querys"

import withApolloClient from '../../withApolloClient'
import CreateUpdateTPAModal from '../Modals/CreateUpdateTPAModal'
import DatetimeRenderer from '../../Material/DatetimeRenderer'


const AllTPAs = gql`query AllTPAs($orderBy: [String], $first:Int!, $cursor:String, $searchTerm:String, $filters: [FilterInput]) {
    allTpas(orderBy: $orderBy, first: $first, after: $cursor, searchTerm: $searchTerm, filters: $filters) {
            edges {
                node {
                    id
                    pk
                    dateAdded
                    dateModified
                    name
                    feeType
                    feeAmount
                    contactName
                    contactEmail
                    contactPhone
                    description
                    history {
                        date
                        user
                        comment
                    }
                }
            }
            pageInfo {
                endCursor
                hasNextPage
            }
        }
        tpaFeeTypeChoices: __type(name: "IncidentsTPAFeeTypeChoices") {
            enumValues {
                name
                description
            }
        }
        tpaNodeFieldsDescriptions: __type(name: "TPANode") {
            fields {
                name
                description
            }
        } 
    }
`
class TPAList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
            loading: false,
            error: "",
            openCollapse: null,
        }
    }
    toggleModal = (modalName) => {
        if (this.state.openModal === modalName) {
            this.setState({ openModal: "" })
        } else {
            this.setState({ openModal: modalName })
        }
    }
    render() {
        const fieldDescriptions = this.props.tpaNodeFieldsDescriptions?.fields.reduce((acc, field) => {
            acc[field.name] = field.description
            return acc
        }, {})

        return (
            <PrimaryListingContainer listLoading={this.props.loading} loadMoreEntries={this.props.allTpas?.pageInfo?.hasNextPage ? this.props.loadMoreEntries : null} refetchListQuery={this.props.refetchQuery}>
                <Table responsive>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th className='actions-th'>Actions</th>
                            {this.props.columnConfig?.filter(col => col?.preferenceSettings?.isVisible).map((column, index) => (
                                column.sortable ?
                                    <th key={column.id} onClick={() => this.props.updateOrder(column.id)} style={{ cursor: "pointer" }}>{this.props.orderBy.some(order => order.includes(column.id)) ? <i className={"fa " + (this.props.orderBy.includes(column.id) ? 'fa-sort-asc' : 'fa-sort-desc')}></i> : <i className='fa fa-sort'></i>}&nbsp;&nbsp;{column.name}</th> :
                                    <th key={column.id}>
                                        {column.name}
                                        {fieldDescriptions && fieldDescriptions.hasOwnProperty(column.id) && fieldDescriptions[column.id] && <>
                                            <i className="fa fa-info-circle ml-1" style={{ fontSize: "12px" }} id={"infoCircle" + column.id} />
                                            <UncontrolledTooltip target={"infoCircle" + column.id} placement="bottom">{fieldDescriptions[column.id]}</UncontrolledTooltip>
                                        </>
                                        }
                                    </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.allTpas?.edges?.length > 0 ? this.props.allTpas.edges.map((tpa, i) =>
                            <>
                                <tr key={i}>
                                    <td>{i + 1}</td>
                                    <td className='actions-td'>
                                        <span className='action-item'>
                                            <i className='fa fa-edit' aria-hidden="true" style={{ cursor: "pointer" }} onClick={() => this.toggleModal(`updateTpa${tpa.node.pk}`)}></i>
                                            {this.state.openModal === `updateTpa${tpa.node.pk}` &&
                                                <CreateUpdateTPAModal
                                                    isOpen={this.state.openModal === `updateTpa${tpa.node.pk}`}
                                                    toggle={() => this.toggleModal("")}
                                                    id={tpa.node.id}
                                                    refetchQuery={this.props.refetchQuery}
                                                />
                                            }
                                        </span>
                                        <span className='action-item'>
                                            <i className='fa fa-history' id={`viewHistory${tpa.node.pk}`} aria-hidden="true" style={{ cursor: "pointer" }} onClick={() => this.toggleModal(`viewHistory${tpa.node.pk}`)}></i>
                                            {this.state.openModal === `viewHistory${tpa.node.pk}` &&
                                                <Popover placement="right" isOpen={this.state.openModal === `viewHistory${tpa.node.pk}`} target={`viewHistory${tpa.node.pk}`} toggle={() => this.toggleModal("")} trigger="legacy">
                                                    <PopoverHeader><strong>Change History Of Item {i + 1}</strong></PopoverHeader>
                                                    <PopoverBody>
                                                        <Row className='mb-1'>
                                                            <Col><strong>Date</strong></Col>
                                                            <Col><strong>User</strong></Col>
                                                            <Col><strong>Comment</strong></Col>
                                                        </Row>
                                                        {tpa.node.history && tpa.node.history.length > 0 ? tpa.node.history.map((historyItem, idx) => (
                                                            <Row key={idx} className="history-item">
                                                                <Col>{<DatetimeRenderer datetime={historyItem.date} />}</Col>
                                                                <Col>{historyItem.user}</Col>
                                                                <Col>{historyItem.comment}</Col>
                                                            </Row>
                                                        )) : <div>No history available.</div>}
                                                    </PopoverBody>
                                                </Popover>
                                            }
                                        </span>
                                    </td>
                                    {this.props.columnConfig?.filter(column => column?.preferenceSettings?.isVisible).map(column => <>
                                        {column.id === "date_added" && <td>{tpa.node.dateAdded ? moment(tpa.node.dateAdded).format("MM/DD/YYYY") : <span className="null-val-color">N/A</span>}</td>}
                                        {column.id === "date_modified" && <td>{tpa.node.dateModified ? moment(tpa.node.dateModified).format("MM/DD/YYYY") : <span className="null-val-color">N/A</span>}</td>}
                                        {column.id === "name" && <td>{tpa.node.name}</td>}
                                        {column.id === "feeType" && <td>{tpa.node.feeType ? toTitleCase(tpa.node.feeType) : <span className="null-val-color">N/A</span>}</td>}
                                        {column.id === "feeAmount" && <td>
                                            {tpa.node.feeAmount !== null && tpa.node.feeAmount !== undefined
                                                ? (tpa.node.feeType === "FLAT"
                                                    ? `$${tpa.node.feeAmount}`
                                                    : `${tpa.node.feeAmount}%`)
                                                : <span className="null-val-color">N/A</span>
                                            }
                                        </td>}
                                        {column.id === "contactName" && <td>{tpa.node.contactName ? tpa.node.contactName : <span className="null-val-color">N/A</span>}</td>}
                                        {column.id === "contactEmail" && <td>{tpa.node.contactEmail ? tpa.node.contactEmail : <span className="null-val-color">N/A</span>}</td>}
                                        {column.id === "contactPhone" && <td>{tpa.node.contactPhone ? tpa.node.contactPhone : <span className="null-val-color">N/A</span>}</td>}
                                        {column.id === "description" && <td>{tpa.node.description ? tpa.node.description : <span className="null-val-color">N/A</span>}</td>}
                                    </>
                                    )}
                                </tr>
                            </>
                        ) : !this.props.loading && <tr>
                            <td colSpan={10}>No TPA found!</td>
                        </tr>
                        }
                    </tbody>
                </Table>
            </PrimaryListingContainer>)
    }
}


const TPAListWithData = graphql(HasPermissionsQuery, {
    options: () => ({
        variables: { userPermissions: [""] },
        fetchPolicy: "network-only",
        notifyOnNetworkStatusChange: true
    }),
    props: ({ data: { hasPermissions, loading, variables } }) => ({
        hasPermissions, loading, variables
    })
})((graphql(AllTPAs, {
    options: ({ searchTerm, orderBy, filters }) => ({
        variables: { first: 30, searchTerm, orderBy, filters },
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'network-only'
    }),
    props: ({ data: { loading, allTpas, fetchMore, variables, tpaFeeTypeChoices, tpaNodeFieldsDescriptions } }) => ({
        loading,
        allTpas,
        variables,
        tpaFeeTypeChoices,
        tpaNodeFieldsDescriptions,
        refetchQuery: () => {
            let currentLength = allTpas && allTpas.edges ? allTpas.edges.length : 30
            return fetchMore({
                query: AllTPAs,
                variables: {
                    ...variables,
                    first: currentLength,
                },
                updateQuery: (previousResult, { fetchMoreResult }) => {
                    const newEdges = fetchMoreResult.allTpas.edges
                    const pageInfo = fetchMoreResult.allTpas.pageInfo
                    return {
                        allTpas: {
                            edges: [...newEdges],
                            pageInfo,
                            __typename: previousResult.allTpas.__typename
                        },
                    }
                },
            })
        },
        loadMoreEntries: () => {
            return fetchMore({
                query: AllTPAs,
                variables: {
                    cursor: allTpas.pageInfo.endCursor,
                    ...variables
                },
                updateQuery: (previousResult, { fetchMoreResult }) => {
                    const newEdges = fetchMoreResult.allTpas.edges
                    const pageInfo = fetchMoreResult.allTpas.pageInfo
                    return {
                        allTpas: {
                            edges: [...previousResult.allTpas.edges, ...newEdges],
                            pageInfo,
                            __typename: previousResult.allTpas.__typename
                        },
                    }
                },
            })
        },
    })
})(withApolloClient(TPAList))))

// Advanced filters live in the URL; feed them as the single `filters` variable.
export default function TPAListWithFilters(props) {
    const [advancedFilters] = useAdvancedFilters()
    return <TPAListWithData {...props} filters={advancedFilters} />
}
